import { InspectionPageEstimateInput } from '../buildInspectionPageEstimateInput';
import { inspectionChecklistSection } from './inspectionChecklistSection';
import { participantContactsSection, signaturesSection } from './inspectionClosingSections';
import { generalStandardSection, inspectionDataSection } from './inspectionDataSection';
import { inspectionIssueRegisterSection } from './inspectionIssueRegisterSection';
import { inspectionSummarySection } from './inspectionSummarySection';
import { numberInspectionSections } from './inspectionPdfTypography';
import { isRenderablePdfBlock, PdfBlock, PdfContent } from './pdf/pdfBlocks';

/**
 * `PdfInspectionItemOutDtoFactory.root`: the report sections in print order, each flowing right after the
 * previous one — no section starts a page of its own.
 */
export function buildInspectionReportBlocks(input: InspectionPageEstimateInput): PdfBlock[] {
  const { parts } = input;
  const numbers = numberInspectionSections(parts);
  const sections: PdfContent[] = [
    parts.inspectionInfo ? inspectionDataSection(input, numbers.inspectionInfo) : undefined,
    parts.inspectionInfo ? generalStandardSection(input) : undefined,
    parts.summary ? inspectionSummarySection(input, numbers.summary) : undefined,
    parts.checklist ? inspectionChecklistSection(input, numbers.checklist) : undefined,
    parts.issueRegister ? inspectionIssueRegisterSection(input, numbers.issueRegister) : undefined,
    participantContactsSection(input),
    parts.signatures ? signaturesSection() : undefined,
  ];
  return sections.filter(isRenderablePdfBlock);
}
